<template>
    <div class="container">
        公司介绍
    </div>
</template>
<script>


export default ({
    data() {
        return{
           
        }
    },
    mounted(){
        this.init()
    },
    methods:{
       init(){;
       },
    }
})

</script>

